import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StageComponent } from './stage.component';
import { MaterialModuleMobi } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppPermissionsPipe, SharedModule } from 'shared-library';



@NgModule({
  declarations: [
    StageComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleMobi,
    FormsModule,  
    ReactiveFormsModule,
    SharedModule,
    AppPermissionsPipe
  ],
  exports: [
    StageComponent
  ]
})
export class StageModule { }
